/**
 * @description This provider and context provides access to the sync results state. The mutator is used by the form to share the sync results
 *  and the accessor is used by the results section to display the results of the operator.
 */

import React from 'react';
import { PropTypes } from 'prop-types';

const SyncResultsContext = React.createContext(null);

const SetSyncResultsContext = React.createContext(() => console.error('SetSyncResults Provider is not defined'));

const SyncResultsProvider = ({ children }) => {
  const [results, setResults] = React.useState(null);

  return (
    <SyncResultsContext.Provider value={results}>
      <SetSyncResultsContext.Provider value={setResults}>
        {children}
      </SetSyncResultsContext.Provider>
    </SyncResultsContext.Provider>
  )
};

SyncResultsProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired
};

export {
  SyncResultsContext,
  SetSyncResultsContext,
  SyncResultsProvider
};
